/**
 * NotFoundPage — catch-all 404 for the SPA.
 *
 * Mirrors the v1 page (verbatim copy would also work — kept locally so the
 * two SPAs stay independent in case their shell layouts diverge later).
 */

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="text-center">
        <h1 className="text-4xl font-semibold mb-2">404</h1>
        <p className="text-sm text-muted-foreground mb-4">
          The page you requested doesn&apos;t exist.
        </p>
        <Link to="/" className="text-sm text-primary underline">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
